import {gsap} from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import {CountUp} from "countup.js";

export class CountNumber {
  constructor() {
    this._numbers = document.querySelectorAll('[animation-number]')

    if (!this._numbers.length) return;

    this.init()
  }

  init() {
    gsap.registerPlugin(ScrollTrigger)

    this._numbers.forEach(number => {
      gsap.to(number, {
        scrollTrigger: {
          trigger: number,
          start: 'top 100%',
          scrub: true,
          onEnter: (e) => {
            this.countNumber(e)
          },
          once: true
        }
      })
    })
  }

  parseAnimationNumber(value) {
    const match = String(value).trim().match(/^([^0-9-]*)(-?[\d]+(?:[.,]\d+)?)([\s\S]*)$/)
    if (!match) return null

    return {
      prefix: match[1],
      endVal: parseFloat(match[2].replace(',', '.')),
      suffix: match[3],
    }
  }

  countNumber(el) {
    const target = el.trigger
    const raw = target.getAttribute('animation-number')
    const parsed = this.parseAnimationNumber(raw)

    if (!parsed) {
      target.textContent = raw
      return
    }

    const count = new CountUp(target, parsed.endVal, {
      duration: 4,
      useGrouping: false,
      prefix: parsed.prefix,
      suffix: parsed.suffix,
    })

    if (!count.error) {
      count.start()
    }
  }
}
